import React, { useEffect, useState } from "react";
import FormHeader from "../FormHeader/FormHeader";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import PopUpModal from "../popupmodal/PopUpModal";
import { useLocation, useNavigate } from "react-router-dom";
import Images from "../../assets";
import { useMutation } from "react-query";
import axios from "axios";
import DatePicker from "react-datepicker";

const AddCustomer = () => {
  const { control, handleSubmit, watch, setValue } = useForm({
    defaultValues: {
      shippinglist: [
        {
          shippingAddressMobNo: "",
          shippingAddressDoorNo: "",
          shippingAddressStreet: "",
          shippingAddressLandMark: "",
          shippingAddressCity: "",
          shippingAddressDistrict: "",
          shippingAddressState: "",
          shippingAddressPincode: "",
          kiloMeter: "",
        },
      ],
    },
  });
  const {
    fields: customerFields,
    append: appendCustomer,
    remove: removeCustomer,
    replace: replaceCustomer,
  } = useFieldArray({
    control,
    name: "shippinglist",
  });
  const navigate = useNavigate();
  const { state } = useLocation();
  const [isPopupOpen, setPopupOpen] = useState(false);
  const togglePopup = () => {
    setPopupOpen(!isPopupOpen);
  };

  // POST API INTEGRATION START
  const { mutate, isSuccess, reset, isLoading } = useMutation(
    async (postData) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_HOST}/customers`,
          postData
        );
        return response.data; // Return data if needed
      } catch (error) {
        console.error("Error in mutation function:", error);
        throw error; // Re-throw the error so that onError is triggered
      }
    },
    {
      onSuccess: () => {
        setPopupOpen(true);
        reset();
        console.log("Customer added successfully.");
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
      },
    }
  );
  // POST API END

  const UpdateAPI = useMutation(
    async (postdata) => {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_HOST}/customers/${state && state?.customerId
          }`,
          postdata
        );
        return response.data; // Return the response to the mutation
      } catch (error) {
        console.error("Error while updating data:", error);
        throw error; // Re-throw the error so that `onError` in useMutation is triggered
      }
    },
    {
      onSuccess: (val) => {
        console.log("Data updated successfully:", val);
        setPopupOpen(!isPopupOpen); // Close popup after success
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
      },
    }
  );

  const getMonthName = (date) => {
    if (!date) return "";
    const monthName = date?.toLocaleString("default", { month: "short" });
    return monthName;
  };

  const convertMonthToDate = (month) => {
    if (!month) return null;
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const monthIndex = monthNames.indexOf(month);
    if (monthIndex === -1) return null;
    const currentYear = new Date().getFullYear(); // Get current year
    return new Date(currentYear, monthIndex, 1); // Create a date for the first day of the given month
  };

  useEffect(() => {
    setValue("aadharNo", state?.aadharNo);
    setValue("city", state?.city);
    setValue("serialName", state?.serialName);
    setValue("customerName", state?.customerName);
    setValue("district", state?.district);
    setValue("doorNo", state?.doorNo);
    setValue("emailId", state?.emailId);
    setValue("gstNumber", state?.gstNumber);
    setValue("landMark", state?.landMark);
    setValue("customerMobileNumber", state?.customerMobileNumber);
    setValue("msmeNumber", state?.msmeNumber);
    setValue("owner", state?.owner);
    setValue("pincode", state?.pincode);

    if (state?.shippinglist?.length > 0) {
      replaceCustomer(
        state?.shippinglist?.map((item) => ({
          shippingAddressMobNo: item?.shippingAddressMobNo || null,
          shippingAddressDoorNo: item?.shippingAddressDoorNo || null,
          shippingAddressStreet: item?.shippingAddressStreet || null,
          shippingAddressLandMark: item?.shippingAddressLandMark || null,
          shippingAddressCity: item?.shippingAddressCity || null,
          shippingAddressDistrict: item?.shippingAddressDistrict || null,
          shippingAddressState: item?.shippingAddressState || null,
          shippingAddressPincode: item?.shippingAddressPincode || null,
          kiloMeter: item?.kiloMeter || null,
        }))
      );
    }
    setValue("state", state?.state);
    setValue("street", state?.street);
    setValue("status", state?.status);
    setValue("salesMode", state?.salesMode);
    const monthDate = convertMonthToDate(state?.month);
    setValue("month", monthDate);
    setValue("discription", state?.discription);
  }, [state, setValue]);

  const onSubmit = (data) => {
    let formData = {
      aadharNo: data?.aadharNo,
      city: data?.city,
      serialName: data?.serialName,
      customerName: data?.customerName,
      district: data?.district,
      doorNo: data?.doorNo,
      emailId: data?.emailId,
      gstNumber: data?.gstNumber,
      landMark: data?.landMark,
      customerMobileNumber: data?.customerMobileNumber,
      msmeNumber: data?.msmeNumber,
      owner: data?.owner,
      pincode: data?.pincode,
      shippinglist: data?.shippinglist,
      state: data?.state,
      street: data?.street,
      month: getMonthName(data?.month),
      salesMode: data?.salesMode,
      status: data?.status,
      discription: data?.discription,
    };
    if (state && state?.customerId) {
      UpdateAPI.mutate(formData);
    } else {
      mutate(formData);
    }
  };

  return (
    <>
      <div className="add_customer_main_section p-0 m-0">
        <div className="add_customer_sub_block">
          <header>
            <FormHeader header="ADD CUSTOMER" />
          </header>
          <h6 className="packing-list-sub-heading  my-4">CUSTOMER DETAILS</h6>
          <form onSubmit={handleSubmit(onSubmit)}>
            {/* <div className="row add_user_input_block">
              <div className="col-2">
                <label className="add_customer_label">CUSTOMER ID :</label>
              </div>
              <div className="col-2 p-0 m-0">
                <Controller
                  control={control}
                  name="serialName"
                  render={({ field }) => (
                    <input
                      className="add_customer_input_field"
                      {...field}
                      type="text"
                      placeholder="BTC0001"
                    />
                  )}
                />
              </div>
              <div className="col-2">
                <label className="add_customer_label">CUSTOMER NAME :</label>
              </div>
              <div className="col-2 p-0 m-0">
                <Controller
                  control={control}
                  name="customerName"
                  render={({ field }) => (
                    <input
                      className="add_customer_input_field"
                      {...field}
                      type="text"
                      placeholder="SARAVANA PACKING"
                    />
                  )}
                />
              </div>
              <div className="col-2">
                <label className="add_customer_label">OWNER :</label>
              </div>
              <div className="col-2 p-0 m-0">
                <Controller
                  control={control}
                  name="owner"
                  render={({ field }) => (
                    <input
                      className="add_customer_input_field"
                      {...field}
                      type="text"
                      placeholder="ASHOK"
                    />
                  )}
                />
              </div>
            </div> */}
            <div className="row g-3 add_user_input_block">
              <div className="col-12 col-md-2">
                <label className="add_customer_label">CUSTOMER ID :</label>
              </div>
              <div className="col-12 col-md-2">
                <Controller
                  control={control}
                  name="serialName"
                  render={({ field }) => (
                    <input
                      className="add_customer_input_field w-100"
                      {...field}
                      type="text"
                      placeholder="BTC0001"
                    />
                  )}
                />
              </div>

              <div className="col-12 col-md-2">
                <label className="add_customer_label">CUSTOMER NAME :</label>
              </div>
              <div className="col-12 col-md-2">
                <Controller
                  control={control}
                  name="customerName"
                  render={({ field }) => (
                    <input
                      className="add_customer_input_field w-100"
                      {...field}
                      type="text"
                      placeholder="SARAVANA PACKING"
                    />
                  )}
                />
              </div>

              <div className="col-12 col-md-2">
                <label className="add_customer_label">OWNER :</label>
              </div>
              <div className="col-12 col-md-2">
                <Controller
                  control={control}
                  name="owner"
                  render={({ field }) => (
                    <input
                      className="add_customer_input_field w-100"
                      {...field}
                      type="text"
                      placeholder="ASHOK"
                    />
                  )}
                />
              </div>
            </div>
            <div className="row g-3 add_user_input_block">
              <div className="col-12 col-md-2">
                <label className="add_customer_label">MOBILE NUMBER :</label>
              </div>
              <div className="col-12 col-md-2">
                <Controller
                  control={control}
                  name="customerMobileNumber"
                  render={({ field }) => (
                    <input
                      className="add_customer_input_field w-100"
                      {...field}
                      type="tel"
                      placeholder="7010489435"
                    />
                  )}
                />
              </div>

              <div className="col-12 col-md-2">
                <label className="add_customer_label">EMAIL ID:</label>
              </div>
              <div className="col-12 col-md-2">
                <Controller
                  control={control}
                  name="emailId"
                  render={({ field }) => (
                    <input
                      className="add_customer_input_field w-100"
                      {...field}
                      type="email"
                      placeholder="example@gmail.com"
                    />
                  )}
                />
              </div>

              <div className="col-12 col-md-2">
                <label className="add_customer_label">MSME NUMBER :</label>
              </div>
              <div className="col-12 col-md-2">
                <Controller
                  control={control}
                  name="msmeNumber"
                  render={({ field }) => (
                    <input
                      className="add_customer_input_field w-100"
                      {...field}
                      type="text"
                      placeholder="*******"
                    />
                  )}
                />
              </div>
            </div>


            <div className="row g-3 add_user_input_block">
              <div className="col-12 col-md-2">
                <label className="add_customer_label">AADHAR NUMBER :</label>
              </div>
              <div className="col-12 col-md-2">
                <Controller
                  control={control}
                  name="aadharNo"
                  render={({ field }) => (
                    <input
                      className="add_customer_input_field w-100"
                      {...field}
                      type="tel"
                      placeholder="********"
                    />
                  )}
                />
              </div>

              <div className="col-12 col-md-2">
                <label className="add_customer_label">GST NUMBER :</label>
              </div>
              <div className="col-12 col-md-2">
                <Controller
                  control={control}
                  name="gstNumber"
                  render={({ field }) => (
                    <input
                      className="add_customer_input_field w-100"
                      {...field}
                      type="text"
                      placeholder="33GRDPS9509A1ZS"
                    />
                  )}
                />
              </div>

              <div className="col-12 col-md-2">
                <label className="add_customer_label">SALES MODE :</label>
              </div>
              <div className="col-12 col-md-2">
                <Controller
                  control={control}
                  name="salesMode"
                  render={({ field }) => (
                    <select
                      {...field}
                      className="add_customer_input_field w-100"
                    >
                      <option value=""></option>
                      <option value="CASH">CASH</option>
                      <option value="CREDIT">CREDIT</option>
                    </select>
                  )}
                />
              </div>
            </div>

            <h6 className="packing-list-sub-heading  my-4">REMAINDER</h6>
            {/* MONTH ROW */}
            <div className="row g-3 add_user_input_block">
              <div className="col-12 col-md-2">
                <label className="add_customer_label">MONTH :</label>
              </div>
              <div className="col-12 col-md-2">
                <Controller
                  name="month"
                  control={control}
                  render={({ field }) => (
                    <DatePicker
                      {...field}
                      selected={field.value}
                      onChange={(date) => field.onChange(date)}
                      dateFormat="MMM"
                      showMonthYearPicker
                      placeholderText="Jan"
                      className="add_customer_input_field w-100"
                    />
                  )}
                />
              </div>
            </div>

            {/* ITEMS ROW */}
            <div className="row g-3 add_user_input_block">
              <div className="col-12 col-md-2">
                <label className="add_customer_label">ITEMS :</label>
              </div>
              <div className="col-12 col-md-10">
                <Controller
                  control={control}
                  name="discription"
                  render={({ field }) => (
                    <textarea
                      {...field}
                      className="add_customer_input_field w-100"
                      style={{ height: "55px", padding: "5px" }}
                      placeholder="Eg. Logs"
                    />
                  )}
                />
              </div>
            </div>


            <h6 className="packing-list-sub-heading  my-4 mx-0">
              BILLING ADDRESS
            </h6>
            <div className="row g-3 add_user_input_block">
              {/* DOOR NO */}
              <div className="col-12 col-md-2">
                <label className="add_customer_label">DOOR NO :</label>
              </div>
              <div className="col-12 col-md-2">
                <Controller
                  control={control}
                  name="doorNo"
                  render={({ field }) => (
                    <input
                      className="add_customer_input_field w-100"
                      {...field}
                      type="text"
                      placeholder="NO.16"
                    />
                  )}
                />
              </div>

              {/* STREET */}
              <div className="col-12 col-md-2">
                <label className="add_customer_label">STREET :</label>
              </div>
              <div className="col-12 col-md-2">
                <Controller
                  control={control}
                  name="street"
                  render={({ field }) => (
                    <input
                      className="add_customer_input_field w-100"
                      {...field}
                      type="text"
                      placeholder="AYAPPAKAM ROAD"
                    />
                  )}
                />
              </div>

              {/* LANDMARK */}
              <div className="col-12 col-md-2">
                <label className="add_customer_label">LANDMARK :</label>
              </div>
              <div className="col-12 col-md-2">
                <Controller
                  control={control}
                  name="landMark"
                  render={({ field }) => (
                    <input
                      className="add_customer_input_field w-100"
                      {...field}
                      type="text"
                      placeholder="MGR PURAM"
                    />
                  )}
                />
              </div>
            </div>

            <div className="row g-3 add_user_input_block">
              {/* CITY */}
              <div className="col-12 col-md-2">
                <label className="add_customer_label">CITY :</label>
              </div>
              <div className="col-12 col-md-2">
                <Controller
                  control={control}
                  name="city"
                  render={({ field }) => (
                    <input
                      className="add_customer_input_field w-100"
                      {...field}
                      type="text"
                      placeholder="TIRUVALLUR"
                    />
                  )}
                />
              </div>

              {/* DISTRICT */}
              <div className="col-12 col-md-2">
                <label className="add_customer_label">DISTRICT :</label>
              </div>
              <div className="col-12 col-md-2">
                <Controller
                  control={control}
                  name="district"
                  render={({ field }) => (
                    <input
                      className="add_customer_input_field w-100"
                      {...field}
                      type="text"
                      placeholder="TIRUVALLUR"
                    />
                  )}
                />
              </div>

              {/* STATE */}
              <div className="col-12 col-md-2">
                <label className="add_customer_label">STATE :</label>
              </div>
              <div className="col-12 col-md-2">
                <Controller
                  control={control}
                  name="state"
                  render={({ field }) => (
                    <input
                      className="add_customer_input_field w-100"
                      {...field}
                      type="text"
                      placeholder="TAMILNADU"
                    />
                  )}
                />
              </div>
            </div>

            <div className="row g-3 add_user_input_block">
              {/* PIN-CODE */}
              <div className="col-12 col-md-2">
                <label className="add_customer_label">PIN-CODE :</label>
              </div>
              <div className="col-12 col-md-2">
                <Controller
                  control={control}
                  name="pincode"
                  render={({ field }) => (
                    <input
                      className="add_customer_input_field w-100"
                      {...field}
                      type="text"
                      placeholder="600058"
                    />
                  )}
                />
              </div>
            </div>

            <h6 className="packing-list-sub-heading  my-4 mx-0">
              SHIPPING ADDRESS
            </h6>
            {customerFields?.map((field, index) => {
              return (
                <>
                  <div key={field?.id}>
                    <h6 className="packing-list-sub-heading  my-4 mx-0">
                      ADDRESS {index + 1}
                    </h6>
                    {index > 0 && (
                      <>
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "end",
                            padding: "10px 20px",
                          }}
                        >
                          <img
                            src={Images?.deleteIcon}
                            alt="no-image"
                            style={{
                              width: "25px",
                              height: "25px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              removeCustomer(index);
                            }}
                          />
                        </div>
                      </>
                    )}
                    <div className="row g-3 add_user_input_block">
                      {/* MOBILE NUMBER */}
                      <div className="col-12 col-md-2">
                        <label className="add_customer_label">MOBILE NUMBER :</label>
                      </div>
                      <div className="col-12 col-md-2">
                        <Controller
                          control={control}
                          name={`shippinglist.${index}.shippingAddressMobNo`}
                          render={({ field }) => (
                            <input
                              className="add_customer_input_field w-100"
                              {...field}
                              type="tel"
                              placeholder="7010489435"
                            />
                          )}
                        />
                      </div>

                      {/* DOOR NO */}
                      <div className="col-12 col-md-2">
                        <label className="add_customer_label">DOOR NO :</label>
                      </div>
                      <div className="col-12 col-md-2">
                        <Controller
                          control={control}
                          name={`shippinglist.${index}.shippingAddressDoorNo`}
                          render={({ field }) => (
                            <input
                              className="add_customer_input_field w-100"
                              {...field}
                              type="text"
                              placeholder="NO.16"
                            />
                          )}
                        />
                      </div>

                      {/* STREET */}
                      <div className="col-12 col-md-2">
                        <label className="add_customer_label">STREET :</label>
                      </div>
                      <div className="col-12 col-md-2">
                        <Controller
                          control={control}
                          name={`shippinglist.${index}.shippingAddressStreet`}
                          render={({ field }) => (
                            <input
                              className="add_customer_input_field w-100"
                              {...field}
                              type="text"
                              placeholder="AYAPPAKAM ROAD"
                            />
                          )}
                        />
                      </div>
                    </div>

                    <div className="row g-3 add_user_input_block">
                      {/* LANDMARK */}
                      <div className="col-12 col-md-2">
                        <label className="add_customer_label">LANDMARK :</label>
                      </div>
                      <div className="col-12 col-md-2">
                        <Controller
                          control={control}
                          name={`shippinglist.${index}.shippingAddressLandMark`}
                          render={({ field }) => (
                            <input
                              className="add_customer_input_field w-100"
                              {...field}
                              type="text"
                              placeholder="MGR PURAM"
                            />
                          )}
                        />
                      </div>

                      {/* CITY */}
                      <div className="col-12 col-md-2">
                        <label className="add_customer_label">CITY :</label>
                      </div>
                      <div className="col-12 col-md-2">
                        <Controller
                          control={control}
                          name={`shippinglist.${index}.shippingAddressCity`}
                          render={({ field }) => (
                            <input
                              className="add_customer_input_field w-100"
                              {...field}
                              type="text"
                              placeholder="TIRUVALLUR"
                            />
                          )}
                        />
                      </div>

                      {/* DISTRICT */}
                      <div className="col-12 col-md-2">
                        <label className="add_customer_label">DISTRICT :</label>
                      </div>
                      <div className="col-12 col-md-2">
                        <Controller
                          control={control}
                          name={`shippinglist.${index}.shippingAddressDistrict`}
                          render={({ field }) => (
                            <input
                              className="add_customer_input_field w-100"
                              {...field}
                              type="text"
                              placeholder="TIRUVALLUR"
                            />
                          )}
                        />
                      </div>
                    </div>

                    <div className="row g-3 add_user_input_block">
                      {/* STATE */}
                      <div className="col-12 col-md-2">
                        <label className="add_customer_label">STATE :</label>
                      </div>
                      <div className="col-12 col-md-2">
                        <Controller
                          control={control}
                          name={`shippinglist.${index}.shippingAddressState`}
                          render={({ field }) => (
                            <input
                              className="add_customer_input_field w-100"
                              {...field}
                              type="text"
                              placeholder="TAMILNADU"
                            />
                          )}
                        />
                      </div>

                      {/* PIN-CODE */}
                      <div className="col-12 col-md-2">
                        <label className="add_customer_label">PIN-CODE :</label>
                      </div>
                      <div className="col-12 col-md-2">
                        <Controller
                          control={control}
                          name={`shippinglist.${index}.shippingAddressPincode`}
                          render={({ field }) => (
                            <input
                              className="add_customer_input_field w-100"
                              {...field}
                              type="text"
                              placeholder="636323"
                            />
                          )}
                        />
                      </div>

                      {/* KILO-METER */}
                      <div className="col-12 col-md-2">
                        <label className="add_customer_label">KILO-METER (KM) :</label>
                      </div>
                      <div className="col-12 col-md-2">
                        <Controller
                          control={control}
                          name={`shippinglist.${index}.kiloMeter`}
                          render={({ field }) => (
                            <input
                              className="add_customer_input_field w-100"
                              {...field}
                              type="text"
                              placeholder="100"
                            />
                          )}
                        />
                      </div>
                    </div>

                  </div>
                </>
              );
            })}

            <div
              className="row  add_user_input_block my-5"
              onClick={() => {
                appendCustomer({
                  shippingAddressMobNo: "",
                  shippingAddressDoorNo: "",
                  shippingAddressStreet: "",
                  shippingAddressLandMark: "",
                  shippingAddressCity: "",
                  shippingAddressDistrict: "",
                  shippingAddressState: "",
                  shippingAddressPincode: "",
                  kiloMeter: "",
                });
              }}
            >
              <div className="col-12 shippingAdressAppendBlock">
                <div className="shippingAdressInnerBlock">
                  <h5 className="shippingAddressAppendHeading">ADD ADDRESS</h5>
                </div>
              </div>
            </div>
            <div className="row my-5">
              <div className="col-12 d-flex justify-content-center">
                <button className="add_customer_submit_btn">
                  {isLoading ? (
                    <i class="fa fa-spinner fa-spin"></i>
                  ) : (
                    <>SUBMIT</>
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <PopUpModal isOpen={isPopupOpen} onClose={togglePopup}>
        <div className="img-block">
          <div style={{ width: "40%", height: "60%" }} className="mx-2 pt-2">
            <img
              src={Images?.logo}
              style={{ width: "100%", height: "100%" }}
              alt="No-Image"
            />
          </div>
        </div>
        <div className="d-flex flex-column align-items-center justify-content-center py-2">
          {state && state?.id ? (
            <>
              <h6 className="popup-content mb-3">
                Customer Has Been Updated Successfuly
              </h6>
            </>
          ) : (
            <>
              <h6 className="popup-content mb-3">
                Customer Has Been Added Successfuly
              </h6>
            </>
          )}

          <button
            className="user-add-button mt-2 mb-2"
            onClick={() => {
              navigate("/viewCustomer");
            }}
          >
            OK
          </button>
        </div>
      </PopUpModal>
    </>
  );
};

export default AddCustomer;
